import { get } from "api/axiosApi";
import { env } from "utils/env";

const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

const getPositions = () => {
  return get(`${masterPartnerUrl}/dictionaries/contactPersonRole/`);
};

const getPartnerDetails = uniqueId => {
  return get(`${masterPartnerUrl}/partners/${uniqueId}/lite`);
};

const getPersons = search => {
  return get(`${masterPartnerUrl}/dictionaries/persons?search=${search}`);
};

const getSegregatedPersons = search => {
  return get(`${masterPartnerUrl}/dictionaries/persons?search=${search}`);
};

const exp = {
  getPositions,
  getPartnerDetails,
  getPersons,
  getSegregatedPersons
};
export default exp;
